import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';

@Component({
  selector: 'app-confirmation-modal',
  templateUrl: 'confirmation-modal.html',
  styleUrls: ['./confirmation-modal.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ConfirmationModalComponent implements OnInit {
  beerName: string;

  constructor(private dialogRef: MatDialogRef<ConfirmationModalComponent>,
              @Inject(MAT_DIALOG_DATA) public data: any,
              private cd: ChangeDetectorRef) {
  }

  ngOnInit(): void {
    if (this.data) {
      this.beerName = this.data.beerName;
      this.cd.markForCheck();
    }
  }

  closeModal(result: boolean) {
    this.dialogRef.close(result);
  }

}
